import { useNovelViewer } from "../../../../models/viewer/useNovelViewer"
import { useNovel } from "../../../hooks/novel/useNovel"
import { Viewer } from "./Viewer"
import PageNotFound from "../../PageNotFound"
import { getErrorType } from "../../../../libs/getErrorType"
import ErrorFallback from "../../../ErrorFallback"
import React from "react"

type Props = {
  novelId: number
  chapterId: number
}

export const NovelViewerPage = ({ novelId, chapterId }: Props): JSX.Element => {
  const { viewerData, error: viewerError } = useNovelViewer({ chapterId })
  const { novel, error: novelError } = useNovel(novelId, "guestNovel")

  if (viewerData === undefined || novel === undefined) {
    return <div>Loading...</div>
  }

  const errorType = getErrorType([viewerError, novelError])

  if (errorType === "NOT_FOUND") {
    return <PageNotFound />
  }

  if (errorType === "UNKNOWN") {
    return <ErrorFallback />
  }

  const publicChapters =
    novel.chapters?.filter((chapter) => chapter.is_published) || []
  const targetChapter = publicChapters.find((v) => v.id === chapterId)

  if (!targetChapter) {
    return <PageNotFound />
  }

  return <Viewer chapterId={chapterId} viewer={viewerData} novel={novel} />
}
